<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :types="['department', 'com_name', 'rank', 'writer_name', 'date']">
      <template #after-custom-row>
        <vs-row class="mb-4" style="display: grid; grid-template-columns: 114px 1fr" vs-align="center">
          <vs-col class="label-text mr-4">{{ $t('분야명') }}</vs-col>
          <vs-col>
            <div v-if="isPrint" class="print-input">{{ form.stdInfo.field_name }}</div>
            <ml-input v-else class="w-full" :value="form.stdInfo.field_name" :readonly="true" />
          </vs-col>
        </vs-row>
      </template>
    </field-select-module>

    <!-- 신규 사업장 개요 -->
    <div>
      <vs-row  class="my-4">
        <vs-col>
          <h5><i class="dot"></i>{{ $t('신규 사업장 개요') }}</h5>
        </vs-col>
      </vs-row>
      <div class="w-full grid items-start" style="grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem">
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">{{ $t('사업장명') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.field_name }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.field_name" placeholder="입력필드" class="w-full flex-1" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">{{ $t('담당 주무관') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.director_name }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.manager_name" placeholder="입력필드" class="w-full flex-1" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">{{ $t('사업기간') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.work_begin_at }} ~ {{ form.work_end_at }}</p>
          <div v-else class="flex items-center gap-3">
            <date-selector :readonly="board.readonly" v-model="form.work_begin_at" class="w-full flex-1" :placeholder="$t('선택')" />
            <span>~</span>
            <date-selector :readonly="board.readonly" v-model="form.work_end_at" class="w-full flex-1" :placeholder="$t('선택')" />
          </div>
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">{{ $t('사업금액') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.deposit_amount }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.deposit_amount" placeholder="입력필드" class="w-full flex-1" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">{{ $t('사업장 주소') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.address }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.address" placeholder="입력필드" class="w-full flex-1" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">{{ $t('사업장 연락처') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.phone }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.phone" placeholder="입력필드" class="w-full flex-1" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">{{ $t('원료·제조물 해당 법령') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.applicable_law }}</p>
          <div v-else class="w-full flex-1">
            <ml-input :readonly="board.readonly" v-model="form.applicable_law" placeholder="입력필드" class="w-full flex-1" />
            <div style="color: #696d71;">{{ $t('※ 중처법 제8조제3호참고') }}</div>
          </div>
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 128px 1fr; align-items: center">
          <div class="label-text mr-4">{{ $t('구체적 사용처') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.specific_uses }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.specific_uses" placeholder="입력필드" class="w-full flex-1" />
        </div>
      </div>
    </div>

    <!-- 수급업체 정보 -->
    <FieldWorkplaceTable :readonly="board.readonly" :isPrint="isPrint" :has-inspector="false" v-model="form.infoDatas" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldWorkplaceTable from "@/components/FieldWorkplaceTable.vue";
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    FieldSelectModule,
    FieldWorkplaceTable,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},

        field_name: "", // 사업장명
        director_name: "", // 담당 주무관
        work_begin_at: "", // 사업기간 시작
        work_end_at: "", // 사업기간 끝
        deposit_amount: "", // 사업금액
        address: "", // 사업장 주소
        phone: "", // 사업장 연락처
        applicable_law: "", // 해당 법령
        specific_uses: "",  // 사용청

        company_ids: [], // 참여 업체 목록
        user_ids: [], // 참여 사용자 목록

        field_view: {}, // 현장 조감도
        field_map: {}, // 현장 약도
        field_photo: {}, // 현장 사진
        start_work_at: "",
        be_completed_at: "",

        facility_category_id: "",
        meta: "", // 부가 정보

        manager_name: "", // 현장소장
        safety_manager_name: "", // 안전관리자
        contract_code: "", // 계약번호
        infoDatas: [],
      },

      cat1List: [],
      cat2List: [],
      cat3List: [],
    };
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
    projectInfo: {
      immediate: true,
      deep: true,
      handler(/*value*/) {
        if (!this.form.stdInfo.field_name) this.form.stdInfo.field_name = this.projectInfo.field_name;
      },
    },
  },
  async mounted() {
    //
  },
  methods: {
    //
  },
};
</script>

<style scoped lang="scss"></style>
